import React from "react";
import labImg from "../../assets/acreddited.jpg";

const AccreditationSection = () => {
  return (
    <section className="flex flex-col md:flex-row items-center justify-between pt-16  p-8 bg-gray-100 pb-24">
      {/* Left Side: Description */}
      <div className="md:w-1/2 w-full text-left mx-auto max-w-[700px]">
        <h2 className="text-3xl sm:text-2xl md:text-3xl text-center font-bold mb-4 text-custom-pink">
          REGISTERED AND ACCREDITED BY NACTE
        </h2>
        <span className="inline-block border-solid border-b-4 border-gold mb-4 w-28 h-2 mx-auto md:ml-16"></span>
        <p className="text-lg sm:text-base md:text-lg leading-relaxed font-normal mb-6 text-left tracking-wide md:ml-12">
          The College is accredited by the National Council for Technical
          Education (NACTE) to run and grant awards to successful candidates in
          technician and engineering programmes. Awards offered are Ordinary
          Diploma, namely the National Technical Level (NTA) 4 – 6. JRIIT is
          guided by well-defined philosophy and core values. The Institute’s
          philosophy is to become an agent of change in public and private
          sector by offering quality market- driven academic and professional
          training and consultancy service. Our core values include customer
          focus, academic freedom, accountability, competence, excellence
          fairness, gender equity and diversity as well as integrity.
        </p>
      </div>

      {/* Right Side: Image */}
      <div className="md:w-1/2 w-full mt-8 md:mt-0">
        <img
          src={labImg}
          alt="Engineering students working in the lab"
          className="w-full sm:w-4/5 h-auto object-cover rounded-lg shadow-lg mx-auto md:mx-0"
        />
      </div>
    </section>
  );
};

export default AccreditationSection;
